<div id="Activation-Interstitial">
  <div class="row no-gutters inner-content">
    <div class="col-12">
      <picture>
        <source media="(min-width: 767px)" srcset="assets/images/communication-alerts-pictogram.svg">
        <img src="assets/images/communication-alerts-pictogram.svg" alt="alert-pictogram icon">
      </picture>
    </div>
    <div class="col-12">
      <h2 class="header">{{cfetLabels.cfet_document_review.doc_utf_header}}</h2>
    </div>
    <div class="col-12">
      <p class="subcontent">{{cfetLabels.cfet_document_review.doc_utf_subcontent}}</p>
    </div>
  </div>
  <hr />
  <div class="btn-container">
    <a tabindex="0" type="button" id="cancel_link" (click)="cancel($event)" (keyup)="cancel($event)">
      <em aria-label=""></em>{{cfetButtonLabels.button_labels.cancel}}</a>
    <button tabindex="0" type="button" id="btn-continue" class="btn btn-alt btn-medium"
      (click)="continueToProfile($event)" (keyup)="continueToProfile($event)">
      {{cfetButtonLabels.button_labels.continue}}</button>
  </div>
</div>